import { fetcher } from "helpers/fetcher";

import { TGetCompanyMatchingReq, TGetCompanyMatchingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCompanyMatching = async (payload?: TGetCompanyMatchingReq) => {
  return await fetcher<TGetCompanyMatchingRes, TGetCompanyMatchingReq["data"]>(
    ENDPOINT.BU.GET_COMPANY_MATCHING,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_COMPANY_MATCHING.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
    }
  );
};

export const queryGetCompanyMatching = async (
  params?: TGetCompanyMatchingReq
) => {
  return (await getCompanyMatching(params)).data;
};

queryGetCompanyMatching._key = (
  params?: TGetCompanyMatchingReq,
  key?: string
) => [ENDPOINT.BU.GET_COMPANY_MATCHING.url, params, key];
